import { LOCALE_HTML_LANG, type LocaleId } from "@dawn/i18n";
import type { CareerAggregates, CompletedRunRecord } from "@dawn/adapters";

function formatCompletionDate(completedAt: string, locale: LocaleId): string {
  const date = new Date(completedAt);
  return new Intl.DateTimeFormat(LOCALE_HTML_LANG[locale], {
    dateStyle: "medium",
  }).format(date);
}

function formatExploredFraction(fraction: number | null): string {
  if (fraction === null) {
    return "—";
  }

  return `${Math.round(fraction * 100)}%`;
}

export function formatCareerTeaser(
  template: string,
  aggregates: CareerAggregates,
): string {
  return template
    .replace("{wins}", String(aggregates.totalWins))
    .replace("{fastest}", String(aggregates.fastestWinTurns ?? ""))
    .replace("{explored}", formatExploredFraction(aggregates.mostExploredFraction));
}

export function formatChronicleEntry(
  template: string,
  record: CompletedRunRecord,
  locale: LocaleId,
): string {
  return template
    .replace("{clanName}", record.clanName)
    .replace("{turns}", String(record.turns))
    .replace("{date}", formatCompletionDate(record.completedAt, locale));
}
